'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeSample = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    font-size: .8em;\n    padding: 1em;\n    margin: 0;\n    overflow: auto;\n    background: ', ';\n    min-height: 100%;\n'], ['\n    ', '\n    font-size: .8em;\n    padding: 1em;\n    margin: 0;\n    overflow: auto;\n    background: ', ';\n    min-height: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _prismCore = require('prismjs/components/prism-core');

var _prismCore2 = _interopRequireDefault(_prismCore);

require('prismjs/components/prism-clike');

require('prismjs/components/prism-javascript');

require('prismjs/components/prism-python');

require('prismjs/components/prism-markup');

require('prismjs/components/prism-markup-templating');

require('prismjs/components/prism-php');

require('prismjs/components/prism-ruby');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* babel-plugin-inline-import 'prismjs/themes/prism.css' */var prismstyles = '/**\n * prism.js default theme for JavaScript, CSS and HTML\n * Based on dabblet (http://dabblet.com)\n * @author Lea Verou\n */\n\ncode[class*="language-"],\npre[class*="language-"] {\n\tcolor: black;\n\tbackground: none;\n\ttext-shadow: 0 1px white;\n\tfont-family: Consolas, Monaco, \'Andale Mono\', \'Ubuntu Mono\', monospace;\n\ttext-align: left;\n\twhite-space: pre;\n\tword-spacing: normal;\n\tword-break: normal;\n\tword-wrap: normal;\n\tline-height: 1.5;\n\n\t-moz-tab-size: 4;\n\t-o-tab-size: 4;\n\ttab-size: 4;\n\n\t-webkit-hyphens: none;\n\t-moz-hyphens: none;\n\t-ms-hyphens: none;\n\thyphens: none;\n}\n\npre[class*="language-"]::-moz-selection, pre[class*="language-"] ::-moz-selection,\ncode[class*="language-"]::-moz-selection, code[class*="language-"] ::-moz-selection {\n\ttext-shadow: none;\n\tbackground: #b3d4fc;\n}\n\npre[class*="language-"]::selection, pre[class*="language-"] ::selection,\ncode[class*="language-"]::selection, code[class*="language-"] ::selection {\n\ttext-shadow: none;\n\tbackground: #b3d4fc;\n}\n\n@media print {\n\tcode[class*="language-"],\n\tpre[class*="language-"] {\n\t\ttext-shadow: none;\n\t}\n}\n\n/* Code blocks */\npre[class*="language-"] {\n\tpadding: 1em;\n\tmargin: .5em 0;\n\toverflow: auto;\n}\n\n:not(pre) > code[class*="language-"],\npre[class*="language-"] {\n\tbackground: #f5f2f0;\n}\n\n/* Inline code */\n:not(pre) > code[class*="language-"] {\n\tpadding: .1em;\n\tborder-radius: .3em;\n\twhite-space: normal;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n\tcolor: slategray;\n}\n\n.token.punctuation {\n\tcolor: #999;\n}\n\n.namespace {\n\topacity: .7;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n\tcolor: #905;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n\tcolor: #690;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n\tcolor: #9a6e3a;\n\tbackground: hsla(0, 0%, 100%, .5);\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n\tcolor: #07a;\n}\n\n.token.function,\n.token.class-name {\n\tcolor: #DD4A68;\n}\n\n.token.regex,\n.token.important,\n.token.variable {\n\tcolor: #e90;\n}\n\n.token.important,\n.token.bold {\n\tfont-weight: bold;\n}\n.token.italic {\n\tfont-style: italic;\n}\n\n.token.entity {\n\tcursor: help;\n}\n';
var CodeSample = exports.CodeSample = (0, _styledComponents2.default)(function (_ref) {
  var className = _ref.className,
      _ref$lang = _ref.lang,
      lang = _ref$lang === undefined ? 'markup' : _ref$lang,
      children = _ref.children;
  return _react2.default.createElement(
    'pre',
    { className: className + ' language-' + lang },
    _react2.default.createElement('code', { dangerouslySetInnerHTML: { __html: _prismCore2.default.highlight(children.trim(), _prismCore2.default.languages[lang]) } })
  );
})(_templateObject, prismstyles, _styles.styles.colors.mediumbg);
CodeSample.displayName = 'CodeSample';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/CodeSample.js
// module id = 605
// module chunks = 0